// utils/storage.ts

// Function to generate a unique session ID
import { v4 as uuidv4 } from 'uuid';

export const generateSessionId = (): string => {
  return uuidv4();
};

// Function to save the session ID to session storage
export const saveSessionId = (sessionId: string): void => {
  sessionStorage.setItem('sessionId', sessionId);
};

// Function to retrieve the session ID from session storage
export const getSessionId = (): string => {
  let sessionId = sessionStorage.getItem('sessionId');
  if (!sessionId) {
    sessionId = generateSessionId();
    saveSessionId(sessionId);
  }
  return sessionId;
};

// Function to save vote session data to local storage
export const saveVoteSession = (sessionData: any): void => {
  localStorage.setItem(`voteSession_${sessionData.gameId}`, JSON.stringify(sessionData));
};

// Function to retrieve vote session data from local storage
export const getVoteSession = (gameId: string): any => {
  const sessionData = localStorage.getItem(`voteSession_${gameId}`);
  return sessionData ? JSON.parse(sessionData) : null;
};

// Function to check if a user has already voted in a game
export const hasVotedInGame = (gameId: string): boolean => {
  const sessionData = getVoteSession(gameId);
  return !!sessionData?.hasVoted;
};

// Function to reset all voting data
export const resetAllVotingData = (): void => {
  sessionStorage.removeItem('sessionId');
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('voteSession_')) {
      localStorage.removeItem(key);
    }
  }
};

// Auth Helper Functions
export const saveAuthToken = (token: string): void => {
  localStorage.setItem('authToken', token);
};

export const getAuthToken = (): string | null => {
  return localStorage.getItem('authToken');
};

export const removeAuthToken = (): void => {
  localStorage.removeItem('authToken');
};

export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
};

export const getAuthUser = (): any | null => {
  const token = getAuthToken();
  if (!token) return null;
  
  try {
    return JSON.parse(atob(token));
  } catch (error) {
    console.error('Error parsing auth token:', error);
    return null;
  }
};

// Function to save the last used team ID to localStorage
export const saveLastTeamId = (teamId: string): void => {
  localStorage.setItem('lastTeamId', teamId);
};

// Function to retrieve the last used team ID from localStorage
export const getLastTeamId = (): string | null => {
  return localStorage.getItem('lastTeamId');
};
